import { sagaRoot } from "./root";
import { call, put, select, take, takeLatest } from "redux-saga/effects";
import Labels from "../services/apiLabels";
import {
  PLACE_BID,
  PRODUCT_DETAIL,
  PRODUCT_LIST,
  GET_PRODUCT_BIDDING_GRAPH,
  PRODUCT_LIST_BUY,
  PRODUCT_DETAIL_BUY,
  CREATE_SUBSCRIPTION,
  CREATE_CONTACT_US,
  FORGET_PASSWORD,
  SALE_PRODUCT_LIST,
  APPROXY_BID_NEW,
  RESET_PASSWORD,

  SHIPING_COST,
  ADDRESS_FORM,
  ADD_CAR_FEATURES,
  CAR_DETAIL_UPDATE,
  GET,
  VEHICLE_FEATURE_SAVE_SETTLED,
  SHIPING_FORM,
  WINERS_CAR_LIST,
  WINERS_CAR_USER_STATUS,
  DOST_PROGRAM,
} from "../constant";
import { syncCreditsAfterCharge } from "./syncCredits";
// get all product list
export function* ProductListSaga(payload) {
  const { history, query } = payload.payload.params;
  const response = yield call(sagaRoot, payload);
  if (response.message.type === "success") {
    
    history.push({ search: query });
  }
  
}
// get all product detail

export function* ProductDetailSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}
export function* ProductDetailSagaBuy(payload) {
  const response = yield call(sagaRoot, payload);
  
}
export function* ProductListSagaBuy(payload) {
  const response = yield call(sagaRoot, payload);
  
}
function runPayloadCallBack(payload, response) {
  const callBack = payload.payload?.callBack;
  if (typeof callBack === "function") {
    callBack(response);
  }
}

export function* CreateSubscriptionSaga(payload) {
  const response = yield call(sagaRoot, payload);
  runPayloadCallBack(payload, response);
}
export function* CreateContactUsSaga(payload) {
  const response = yield call(sagaRoot, payload);
  runPayloadCallBack(payload, response);
}
export function* SaleProductListSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}
export function* ForgetPasswordSaga(payload) {
  const response = yield call(sagaRoot, payload);
  runPayloadCallBack(payload, response);
}
export function* ApproxyBidSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}
export function* ResSetPasswordNewSaga(payload) {
  const response = yield call(sagaRoot, payload);
  runPayloadCallBack(payload, response);
}
export function* ShipingCastSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}


export function* ShipingCastFormSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}
export function* CarWinerListSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}
export function* CarWinerList_StatusSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}




export function* AddressFormSaga(payload) {
  const response = yield call(sagaRoot, payload);
  if (response?.message?.type === "success") {
    yield call(syncCreditsAfterCharge);
  }
}
export function* CarFeaturesAddSaga(payload) {
  const response = yield call(sagaRoot, payload);
  const evaluationId = payload.payload?.data?.evaluation;
  const saved = response?.message?.type === "success";

  if (saved && evaluationId) {
    const evaluation = yield select((state) => state.sellMyCar.evaluation_create);
    const vehicleData = yield select((state) => state.cardeailupdate.vehicle_data);

    yield put({
      type: CAR_DETAIL_UPDATE,
      payload: {
        type: CAR_DETAIL_UPDATE,
        label: `${Labels.carDetail_Update}?id=${evaluationId}`,
        method: GET,
        hideOverlayLoader: true,
        requestMeta: { silent: true },
        data_vehicle: evaluation?.id ? evaluation : vehicleData,
      },
    });

    yield take([
      `${CAR_DETAIL_UPDATE}_SUCCESS`,
      `${CAR_DETAIL_UPDATE}_FAIL`,
      `${CAR_DETAIL_UPDATE}_ERROR`,
    ]);
  }

  yield put({
    type: VEHICLE_FEATURE_SAVE_SETTLED,
    payload: { success: saved },
  });
}










export function* DostProgramSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}

export function* PlaceBidSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}
export function* GetProductBiddingGraphSaga(payload) {
  const response = yield call(sagaRoot, payload);
  
}

export default function* productWatcher() {
  yield takeLatest(PRODUCT_LIST, ProductListSaga);
  yield takeLatest(PRODUCT_LIST_BUY, ProductListSagaBuy);
  yield takeLatest(PRODUCT_DETAIL, ProductDetailSaga);
  yield takeLatest(PRODUCT_DETAIL_BUY, ProductDetailSagaBuy);
  yield takeLatest(PLACE_BID, PlaceBidSaga);
  yield takeLatest(GET_PRODUCT_BIDDING_GRAPH, GetProductBiddingGraphSaga);
  yield takeLatest( CREATE_SUBSCRIPTION, CreateSubscriptionSaga);
  yield takeLatest( CREATE_CONTACT_US, CreateContactUsSaga);
  yield takeLatest( SALE_PRODUCT_LIST, SaleProductListSaga);
  yield takeLatest( FORGET_PASSWORD, ForgetPasswordSaga);
  yield takeLatest( APPROXY_BID_NEW, ApproxyBidSaga);
  yield takeLatest( RESET_PASSWORD, ResSetPasswordNewSaga);
  yield takeLatest( SHIPING_COST, ShipingCastSaga);

  yield takeLatest( ADDRESS_FORM, AddressFormSaga);
  yield takeLatest( ADD_CAR_FEATURES, CarFeaturesAddSaga);

  yield takeLatest( SHIPING_FORM, ShipingCastFormSaga);
  yield takeLatest( WINERS_CAR_LIST, CarWinerListSaga);
  yield takeLatest( WINERS_CAR_USER_STATUS, CarWinerList_StatusSaga);

  yield takeLatest( DOST_PROGRAM, DostProgramSaga);
}
